import { ServerConfig } from "@/config/config";
import { Axios } from "@/utils/axios";

// Het gekozen (white-label) Clearfacts-domein moet de redirect overleven: de
// token-uitwisseling moet naar dezelfde host als de autorisatie.
export const CLEARFACTS_DOMAIN_STORAGE_KEY = "clearfacts-connect-domain";

export interface IClearfactsStatus {
	Connected: boolean;
	ExpiresAt?: string;
	User?: string;
	Email?: string;
}

export interface IClearfactsAdministration {
	name: string;
	companyNumber: string;
}

export class ClearfactsServiceClass {
	private readonly baseUrl:string = `${ServerConfig.auth}/auth/clearfacts`;

	async getAuthorizeUrl(domain:string = ""):Promise<{URL:string, State:string}>{
		let result = await Axios.get(`${this.baseUrl}/authorize-url`, {params: {domain}});
		return result.data;
	}

	async exchangeCode(code:string, domain:string = ""):Promise<IClearfactsStatus>{
		let result = await Axios.post(`${this.baseUrl}/exchange-code`, {code, domain});
		return result.data;
	}

	async getStatus():Promise<IClearfactsStatus>{
		let result = await Axios.get(`${this.baseUrl}/status`);
		return result.data;
	}

	async disconnect():Promise<void>{
		await Axios.post(`${this.baseUrl}/disconnect`);
	}

	async getAdministrations():Promise<IClearfactsAdministration[]>{
		let result = await Axios.get(`${this.baseUrl}/administrations`);
		return result.data || [];
	}

	// Voor een token dat nog niet opgeslagen is, zodat de dropdown in het
	// portaalformulier al gevuld kan worden.
	async getAdministrationsWithToken(apiKey:string):Promise<IClearfactsAdministration[]>{
		let result = await Axios.post(`${this.baseUrl}/administrations`, {ApiKey: apiKey});
		return result.data || [];
	}
}

export const ClearfactsService = new ClearfactsServiceClass();
